//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    size: {
      type: String,
      default: '',
    },
    isActive: {
      type: Boolean,
      default: undefined,
    },
    href: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isInternalActive: false,
    }
  },
  computed: {
    activeStatusBetweenTwoSources() {
      return typeof this.isActive !== 'undefined' ? this.isActive : this.isInternalActive
    },
  },
  methods: {
    toggleActiveStatus() {
      this.isInternalActive = !this.isInternalActive
      if (this.href) {
        const pathName = `${window.location.pathname}#`
        if (this.href.includes(pathName)) {
          const id = this.href.split(pathName)[1]
          const targetElement = document.getElementById(id)
          const dashButtonBar = this.$parent.$el
          if (targetElement && dashButtonBar) {
            const targetY =
              targetElement.getBoundingClientRect().top +
              window.pageYOffset -
              dashButtonBar.offsetHeight
            window.scrollTo({ top: targetY, behavior: 'smooth' })
          }
        } else {
          window.location.href = this.href
        }
      } else {
        this.$emit('click')
      }
    },
  },
}
